export default {
  translation: {
    nav: {
      home: 'Hjem',
      trips: 'Reiser',
      aboutUs: 'Om oss',
      alerts: 'Varsler',
      wishlist: 'Ønskeliste',
      language: 'Språk',
      profile: 'Profil',
      settings: 'Innstillinger',
      signIn: 'Logg inn',
      signUp: 'Registrer deg'
    },
    hero: {
      title: 'Utforsk Uganda',
      subtitle: 'og videre',
      description: 'Oppdag Afrikas perle med ekspertguider. Uforglemmelige opplevelser venter i Ugandas fantastiske landskap og levende kultur.',
      searchPlaceholder: 'Hvor vil du reise?',
      categories: {
        all: 'Alle',
        wildlife: 'Dyreliv',
        safari: 'Safari',
        cultural: 'Kultur',
        adventure: 'Eventyr',
        birding: 'Fuglekikking'
      }
    },
    common: {
      from: 'fra',
      reviews: 'anmeldelser',
      viewMore: 'Vis mer',
      book: 'Bestill',
      seeAll: 'Se alle',
      loading: 'Laster...'
    }
  }
};